import { ReactElement } from 'react'
import { theme } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis } from 'recharts'
import { AnalyticsTopServicesData } from 'types'
import { useTranslate } from 'utils'
import { CustomChartTooltip } from '../custom-chart-tooltip/custom-chart-tooltip'

type TopServicesChartProps = {
    data: AnalyticsTopServicesData[]
}

export const TopServicesChart = ({
    data
}: TopServicesChartProps): ReactElement => {
    const { __ } = useTranslate()
    const { token: { fontSizeXL, colorTextSecondary }} = theme.useToken()

    return data.length ? (
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    width={500}
                    maxBarSize={120}
                    height={300}
                    data={data.map(dataValue => ({
                        name: dataValue?.title || '',
                        count: dataValue?.count || 0,
                    }))}
                    margin={{
                        top: 15,
                        right: 0,
                        left: 0,
                        bottom: 50,
                    }}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke="#ccc"
                        vertical={false}
                    />
                    <XAxis
                        dataKey="name"
                        strokeWidth={0}
                        tick={({x, y, payload}) => (
                            <text
                                x={x}
                                y={y + 10}
                                fill='#666'
                                fontSize='0.75rem'
                                textAnchor='end'
                                transform={`rotate(-15 ${x}, ${y + 10})`}
                            >
                                { payload.value }
                            </text>
                        )}
                    />
                    <Tooltip
                        content={<CustomChartTooltip />}
                        cursor={{ fill: 'transparent' }}
                    />
                    <Bar
                        type="monotone"
                        dataKey="count"
                        fill="#1dd9e3"
                        activeBar={{ r: 5 }}
                    />
                </BarChart>
        </ResponsiveContainer>
        ) : <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <ExclamationCircleOutlined style={{ fontSize: fontSizeXL, color: colorTextSecondary }} />
                <p style={{ color: colorTextSecondary}}>{ __`nothing_found` }</p>
        </div>
}
